import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { UserSchema } from '@/types/types';
import Button from '../ui/general/Button';
import Table from '../ui/data-display/Table';
import Modal from '../ui/feedback/Modal';

export default function UserSelectModal({
  visible,
  setVisible,
  selectUserEvent,
  users,
}: {
  visible: boolean;
  setVisible: Dispatch<SetStateAction<boolean>>;
  selectUserEvent: (val: UserSchema) => void;
  users: UserSchema[];
}) {
  const { t } = useTranslation();

  const columns = [
    {
      title: t('NAME'),
      key: 'name',
      render: (record: UserSchema) => (
        <>{record.name} {record.surname} {record.motherSurname}</>
      ),
    },
    {
      title: t('USER'),
      key: 'username',
      render: (record: UserSchema) => (
        <>{record.displayName}</>
      ),
    },
    {
      title: t('ACTION'),
      key: 'action',
      render: (record: UserSchema) => (
        <div className="flex gap-4 items-center">
          <Button
            size="small"
            onClick={() => {
              selectUserEvent(record);
            }}
          >
            {t('SELECT')}
          </Button>
        </div>
      ),
    },
  ];

  return (
    <Modal
      title={`${t('SELECT')} ${t('USER')}`}
      isOpen={visible}
      setIsOpen={setVisible}
      width={900}
    >
      <div>
        <Table
          columns={columns}
          dataSource={users}
          isLoading={false}
        />
      </div>
    </Modal>
  );
}
